import { ReactNode, memo } from "react";
import { Box } from "@mui/material";
import { Text } from "$components";
import { IconButton } from "$components/Buttons/IconButton";
import { useStyles } from "./Form.style";

export const FormHeader = memo(function FormHeader({
  icon,
  title,
  onClick,
}: {
  icon?: ReactNode;
  title: string;
  onClick?: (...args: any) => any;
}) {
  const classes = useStyles();
  return (
    <Box className={classes.formHeader}>
      <Text type="h2">{title}</Text>
      {icon && (
        <IconButton
          icon={icon}
          onClick={onClick}
          className={classes.deleteIcon}
        />
      )}
    </Box>
  );
});
